module.exports = __webpack_public_path__ + "static/img/sbpz_logo.19d5d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sbpz_logo.png
// module id = sbXc
// module chunks = 1